import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/user.png'


const _withScopeId = n => (_pushScopeId("data-v-ef9e1df2"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["aria-hidden"]
const _hoisted_2 = { class: "modal-header" }
const _hoisted_3 = { class: "modal-title" }
const _hoisted_4 = ["title"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" }, null, -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "modal-body no-padding" }
const _hoisted_8 = { class: "profile-modal-layout" }
const _hoisted_9 = { class: "profile-modal-left" }
const _hoisted_10 = { class: "modal-profile-image" }
const _hoisted_11 = ["src"]
const _hoisted_12 = {
  key: 1,
  class: "profile-image",
  src: _imports_0,
  alt: "Profile"
}
const _hoisted_13 = { class: "text-center bold" }
const _hoisted_14 = { class: "profile-modal-right" }
const _hoisted_15 = { class: "bold" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-comment-dollar" }, null, -1))
const _hoisted_18 = { key: 1 }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-hand-holding-dollar" }, null, -1))
const _hoisted_20 = { key: 2 }
const _hoisted_21 = { key: 3 }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-link" }, null, -1))
const _hoisted_23 = ["href"]
const _hoisted_24 = { key: 4 }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-location-dot" }, null, -1))
const _hoisted_26 = { key: 5 }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-calendar" }, null, -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-triangle-exclamation" }, null, -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-file-contract" }, null, -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-file-contract" }, null, -1))
const _hoisted_31 = { style: {"margin-bottom":"0px"} }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-file-contract" }, null, -1))
const _hoisted_33 = {
  key: 6,
  class: "container"
}
const _hoisted_34 = { class: "left-content" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-solid fa-star" }, null, -1))
const _hoisted_36 = { class: "right-content" }
const _hoisted_37 = { class: "rating" }
const _hoisted_38 = ["checked"]
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "radio1" }, "★", -1))
const _hoisted_40 = ["checked"]
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "radio2" }, "★", -1))
const _hoisted_42 = ["checked"]
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "radio3" }, "★", -1))
const _hoisted_44 = ["checked"]
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "radio4" }, "★", -1))
const _hoisted_46 = ["checked"]
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "radio5" }, "★", -1))
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-solid fa-comment" }, null, -1))
const _hoisted_49 = { class: "container" }
const _hoisted_50 = { class: "left-content" }
const _hoisted_51 = { class: "form-group" }
const _hoisted_52 = ["disabled"]
const _hoisted_53 = { class: "right-content" }
const _hoisted_54 = { class: "form-group" }
const _hoisted_55 = ["disabled"]
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-paper-plane" }, null, -1))
const _hoisted_57 = { class: "table-responsive" }
const _hoisted_58 = { class: "table" }
const _hoisted_59 = { class: "td-shrink one-line" }
const _hoisted_60 = { class: "td-shrink one-line" }
const _hoisted_61 = { class: "one-line" }
const _hoisted_62 = { class: "one-line" }
const _hoisted_63 = ["innerHTML"]
const _hoisted_64 = { key: 0 }
const _hoisted_65 = { colspan: "3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UserLink = _resolveComponent("UserLink")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["modal-container modal-container-user-profile", { hidden: !_ctx.display }]),
    tabindex: "-1",
    role: "dialog",
    "aria-hidden": !_ctx.display,
    onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args))),
    onKeydown: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.escapeToClose && _ctx.escapeToClose(...args)))
  }, [
    _createElementVNode("div", {
      class: "modal-dialog modal-lg",
      role: "document",
      onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.stopPropagationEvent && _ctx.stopPropagationEvent(...args)))
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t("Profile")) + ": " + _toDisplayString(_ctx.name || _ctx.username || _ctx.$t("Deleted user")), 1),
        _createElementVNode("button", {
          type: "button",
          class: "modal-close-btn",
          title: _ctx.$t('Close'),
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
        }, _hoisted_6, 8, _hoisted_4)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              (_ctx.image)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    class: "profile-image",
                    src: _ctx.getAsset(_ctx.image),
                    alt: "Profile"
                  }, null, 8, _hoisted_11))
                : _createCommentVNode("", true),
              (!_ctx.image)
                ? (_openBlock(), _createElementBlock("img", _hoisted_12))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.username ? "@" + _ctx.username : "[" + _ctx.$t("Deleted") + "]"), 1)
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.name || _ctx.username || _ctx.$t("Deleted user")), 1),
            (_ctx.role === 'borrower')
              ? (_openBlock(), _createElementBlock("p", _hoisted_16, [
                  _hoisted_17,
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t("Verified borrower")), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.role === 'lender')
              ? (_openBlock(), _createElementBlock("p", _hoisted_18, [
                  _hoisted_19,
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t("Verified lender")), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.bio)
              ? (_openBlock(), _createElementBlock("p", _hoisted_20, _toDisplayString(_ctx.bio), 1))
              : _createCommentVNode("", true),
            (_ctx.url)
              ? (_openBlock(), _createElementBlock("p", _hoisted_21, [
                  _hoisted_22,
                  _createElementVNode("a", {
                    href: _ctx.url,
                    target: "_blank",
                    rel: "noopener noreferrer"
                  }, _toDisplayString(_ctx.url), 9, _hoisted_23)
                ]))
              : _createCommentVNode("", true),
            (_ctx.location)
              ? (_openBlock(), _createElementBlock("p", _hoisted_24, [
                  _hoisted_25,
                  _createTextVNode(),
                  _createElementVNode("span", null, _toDisplayString(_ctx.location), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.created)
              ? (_openBlock(), _createElementBlock("p", _hoisted_26, [
                  _hoisted_27,
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t("Joined on")) + ": " + _toDisplayString(_ctx.renderDate(_ctx.created)), 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("p", null, [
              _hoisted_28,
              _createElementVNode("span", null, _toDisplayString(_ctx.$t("Default risk")) + ": " + _toDisplayString(_ctx.renderRisk(_ctx.risk)), 1)
            ]),
            _createElementVNode("p", null, [
              _hoisted_29,
              _createElementVNode("span", null, _toDisplayString(_ctx.$t("Active and signed contracts")) + ": " + _toDisplayString(_ctx.activeContracts), 1)
            ]),
            _createElementVNode("p", null, [
              _hoisted_30,
              _createElementVNode("span", null, _toDisplayString(_ctx.$t("Successfully finished contracts")) + ": " + _toDisplayString(_ctx.paidContracts), 1)
            ]),
            _createElementVNode("p", _hoisted_31, [
              _hoisted_32,
              _createElementVNode("span", null, _toDisplayString(_ctx.$t("Contracts cancelled by default")) + ": " + _toDisplayString(_ctx.cancelledDefaultContracts), 1)
            ]),
            (_ctx.isUser())
              ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                  _createElementVNode("div", _hoisted_34, [
                    _createElementVNode("p", null, [
                      _hoisted_35,
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t("User rating")) + ": " + _toDisplayString(_ctx.averageRating), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_36, [
                    _createElementVNode("p", _hoisted_37, [
                      _createElementVNode("input", {
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setEvaluation(_ctx.uid, 5))),
                        id: "radio1",
                        type: "radio",
                        name: "estrellas",
                        value: "5",
                        checked: _ctx.currentUserRating === 5
                      }, null, 8, _hoisted_38),
                      _hoisted_39,
                      _createElementVNode("input", {
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setEvaluation(_ctx.uid, 4))),
                        id: "radio2",
                        type: "radio",
                        name: "estrellas",
                        value: "4",
                        checked: _ctx.currentUserRating === 4
                      }, null, 8, _hoisted_40),
                      _hoisted_41,
                      _createElementVNode("input", {
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setEvaluation(_ctx.uid, 3))),
                        id: "radio3",
                        type: "radio",
                        name: "estrellas",
                        value: "3",
                        checked: _ctx.currentUserRating === 3
                      }, null, 8, _hoisted_42),
                      _hoisted_43,
                      _createElementVNode("input", {
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.setEvaluation(_ctx.uid, 2))),
                        id: "radio4",
                        type: "radio",
                        name: "estrellas",
                        value: "2",
                        checked: _ctx.currentUserRating === 2
                      }, null, 8, _hoisted_44),
                      _hoisted_45,
                      _createElementVNode("input", {
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.setEvaluation(_ctx.uid, 1))),
                        id: "radio5",
                        type: "radio",
                        name: "estrellas",
                        value: "1",
                        checked: _ctx.currentUserRating === 1
                      }, null, 8, _hoisted_46),
                      _hoisted_47
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("p", {
              class: _normalizeClass({ 'mt-comments': _ctx.isUser() })
            }, [
              _hoisted_48,
              _createElementVNode("span", null, _toDisplayString(_ctx.$t("Comments")), 1)
            ], 2),
            _createElementVNode("div", _hoisted_49, [
              _createElementVNode("div", _hoisted_50, [
                _createElementVNode("div", _hoisted_51, [
                  _withDirectives(_createElementVNode("textarea", {
                    class: "form-control form-control-full-width",
                    maxlength: "500",
                    disabled: _ctx.busy,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.userComment) = $event)),
                    style: {"font-size":"14px"}
                  }, null, 8, _hoisted_52), [
                    [_vModelText, _ctx.userComment]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_53, [
                _createElementVNode("div", _hoisted_54, [
                  _createElementVNode("button", {
                    type: "button",
                    disabled: _ctx.busy || !_ctx.userComment,
                    class: "btn btn-primary btn-sm",
                    onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.sendComment && _ctx.sendComment(...args)))
                  }, [
                    _hoisted_56,
                    _createTextVNode(" " + _toDisplayString(_ctx.$t("Send comment")), 1)
                  ], 8, _hoisted_55)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_57, [
              _createElementVNode("table", _hoisted_58, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", _hoisted_59, _toDisplayString(_ctx.$t("Date")), 1),
                    _createElementVNode("th", _hoisted_60, _toDisplayString(_ctx.$t("User")), 1),
                    _createElementVNode("th", null, _toDisplayString(_ctx.$t("Comment")), 1)
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.comments, (com) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: com.id
                    }, [
                      _createElementVNode("td", _hoisted_61, _toDisplayString(_ctx.renderCommentDate(com.date)), 1),
                      _createElementVNode("td", _hoisted_62, [
                        _createVNode(_component_UserLink, {
                          id: com.userCommentingId.id,
                          name: com.userCommentingId.username
                        }, null, 8, ["id", "name"])
                      ]),
                      _createElementVNode("td", null, [
                        _createElementVNode("div", {
                          class: "com-body",
                          innerHTML: _ctx.renderComment(com.comment)
                        }, null, 8, _hoisted_63)
                      ])
                    ]))
                  }), 128)),
                  (!_ctx.hasMoreComments && _ctx.comments.length === 0)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_64, [
                        _createElementVNode("td", _hoisted_65, _toDisplayString(_ctx.$t("No comments sent for this user yet.")), 1)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ], 42, _hoisted_1))
}